$(document).ready(function(){
    $(".topNav .navBg").click(function () {
        if($(".topNav .items:visible").length >0){
            $(".topNav .items").hide();
        }else{
            $(".topNav .items").show();
        }
    });

    var hoverTimer, outTimer;
    $(".topNav .haveSub").hover(function(){
        var _this=$(this);
        clearTimeout(outTimer);
        hoverTimer = window.setTimeout(function(){
            _this.find(".sub_items").slideDown(300);
        },200);
    },function(){
        var _this=$(this);
        clearTimeout(hoverTimer);
        outTimer = window.setTimeout(function(){
            _this.find(".sub_items").slideUp(200);
        },0);
    });

    $("body").on("click",".topNavMobile .navBg",function () {
        if($(".topNavMobile .items:visible").length==0){
            $(this).siblings(".items").slideDown("300");
        }else{
            $(this).siblings(".items").slideUp("300");
        }
    });

    $("body").on("click",".topNavMobile .haveSub .btn",function () {
        if($(".topNavMobile .sub_items:visible").length==0){
            $(this).closest(".haveSub").find(".sub_items").slideDown("300");
            $(this).addClass("focus");
        }else{
            $(this).closest(".haveSub").find(".sub_items").slideUp("300");
            $(this).removeClass("focus");
        }
    });


});